import { animate, inView, stagger } from "motion";

const quickFacts = document.querySelector<HTMLElement>("[data-quickfacts]");

const runAnimation = () =>
  animate(
    "[data-characteristic-point]",
    { scale: [0, 1] },
    { type: "spring", delay: stagger(0.05) }
  );

if (quickFacts) {
  inView(quickFacts, () => {
    runAnimation();
  });
} else {
  runAnimation();
}
